export const avatars = [
  { name: 'Wild Boars', url: 'avatars/boar.png' },
  { name: 'Raging Dogs', url: 'avatars/pitbull.png' },
  { name: 'Bloody Wolves', url: 'avatars/wolf.png' },
  { name: 'Mighty Grizzlies', url: 'avatars/bear.png' },
  { name: 'Furious Bulls', url: 'avatars/bull.png' },
  { name: 'Ruthless Eagles', url: 'avatars/eagle.png' },
  { name: 'Wicked Goats', url: 'avatars/goat.png' },
  { name: 'Crushing Gorillaz', url: 'avatars/gorilla.png' },
  { name: 'Canny Owls', url: 'avatars/owl.png' },
  { name: 'Lethal Panthers', url: 'avatars/panther.png' },
  { name: 'Brutal Tigers', url: 'avatars/tiger.png' },
  { name: 'Vicious Sharks', url: 'avatars/shark.png' },
]
